import { BoxProps } from '@material-ui/core';

import { Participant } from '../../../../../../../../config/types';
import { IconHeaderCard } from '../../../../../IconHeaderCard';
import { PARTICIPANT_CARD_ICON_BY_ROLE } from '../config';

interface ParticipantCardProps extends BoxProps {
  participant: Participant;
  forceSingleLine?: boolean;
  hideIcon?: boolean;
}

export const ParticipantCard = ({ participant, forceSingleLine, hideIcon = false, ...props }: ParticipantCardProps) => {
  const { name, role, linkTo, onClick, id } = participant;

  return (
    <IconHeaderCard
      copyToClipboard={{ value: id, textId: `COPY_${role}_ID` }}
      surLabelTid={role}
      labelComponent={name}
      color={'minor'}
      linkTo={linkTo}
      onClick={onClick}
      boxProps={{ padding: '14px 16px !important', ...props }}
      forceSingleLine={forceSingleLine}
      {...(!hideIcon && { iconName: PARTICIPANT_CARD_ICON_BY_ROLE[role] })}
    />
  );
};
